import InterviewList, { Columns, OrderValue } from 'components/Interview/List';
import ProfileNavigationHead from 'components/profileNavigation/Head';
import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setOrder, setPage } from 'store/actions/admin/mentorLists';
import { StoreState } from 'store/reducers';
import useSWR from 'swr';
import Interview from 'types/Interview';
import { Action } from 'types/typeguards/reducerActions';

export const activeColumns: Columns = {
  date: true,
  hour: true,
  status: true,
  menteeName: true,
  type: true,
  viewDetails: true,
};

type RetrievedData = {
  interviews: Interview[] | undefined;
  count: number | undefined;
  pages: number | undefined;
};

type Props = {
  page: number;
  setPage: (page: number) => void;
  order: OrderValue;
  setOrder: (order: OrderValue) => void;
};
const Interviews: FC<Props> = ({ page, setPage, order, setOrder }) => {
  const { id } = useParams();
  const { data } = useSWR<RetrievedData>(
    `/interview/mentor/${id}?page=${page}&order=${order}`,
  );
  const [retrievedData, setRetrievedData] = useState<RetrievedData>({
    interviews: undefined,
    count: undefined,
    pages: undefined,
  });
  useEffect(() => {
    if (data) {
      setRetrievedData(data);
    }
  }, [data]);

  // Reset page to 0 if the stored page is out of range
  useEffect(() => {
    if (data?.pages && data?.pages <= page) {
      setPage(0);
    }
  }, [data, page, setPage]);

  return (
    <>
      <ProfileNavigationHead
        title="Liste d'entretiens"
        subtitle="La liste de tous les entretiens programmés par ce mentor"
      />
      <InterviewList
        interviews={retrievedData.interviews}
        variant="adminMentor"
        {...{
          activeColumns,
          page,
          setPage,
          order,
          setOrder,
        }}
        pages={retrievedData.pages}
        loading={!data}
      />
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    page: state.admin.mentorLists.interview.page,
    order: state.admin.mentorLists.interview.order,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setPage: (page: number) => dispatch(setPage('interview', page)),
    setOrder: (order: OrderValue) => dispatch(setOrder('interview', order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Interviews);
